import React from "react";
import { useSelector } from "react-redux";
import { Navigate } from "react-router-dom";

const RequireGuest = ({ children }) => {
  const token = useSelector((state) => state.global.token);
  const role = useSelector((state) => state.global.userRole);

  if (token && role === "admin") {
    return <Navigate to="/admin" replace />;
  }

  return children;
};

export default RequireGuest;
